import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

export const StyledButton = styled(Button)`
  background: ${({ btncolor, theme }) => (btncolor ? btncolor : theme.palette.secondary.grey)};
  color: ${({ fontcolor }) => (fontcolor ? fontcolor : '#232323')};
  width: 100%;
  border-radius: 0;
  text-transform: capitalize;
  font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px` : '20px')};
  min-height: 47px;
  box-shadow: none !important;
  .MuiCircularProgress-colorSecondary {
    width: 30px !important;
    height: 30px !important;
  }
  border-box: none;
  &:hover {
    background: ${({ btncolor, theme }) => (btncolor ? btncolor : theme.palette.primary.main)};
    color: white;
  }
  @media only screen and (max-width: 768px) {
    font-size: 12px;
  }
  @media only screen and (max-width: 768px) {
    font-size: 10px;
  }
  @media only screen and (max-width: 768px) {
    font-size: 16px;
  }
`;

export const StyledLink = styled(Link)`
  color: ${({ color, theme }) => (color ? color : theme.palette.primary.main)};
  &:hover {
    color: ${({ color, theme }) => (color ? color : theme.palette.primary.main)};
    opacity: 0.8;
  }
`;
